import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "boxicons/css/boxicons.css"
import "@/assets/css/style.css"
//import '@vueform/multiselect/themes/default.css'
import "bootstrap/dist/js/bootstrap.js"
createApp(App).use(store).use(router).mount('#app')
